export default __webpack_public_path__ + "media/mdwp-logo.0994f8c7.png";